exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-select-rank-table-list[data-v-b095a646]{width:100%;flex:1;overflow:hidden}\n", ""]);

